// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] + "-legacy." + {"265":"d26ea62c","297":"ef41e640","643":"164b44b2"}[chunkId] + ".js";
};